<template>
  <div>
    <info-generales :ordre-travail="ordreTravail"
      :isOTImpression="isOTImpression"></info-generales>
    <div
      v-if="showCampagne"
      class="mgt-20px">
      <div class="mgt-20px">
        <div class="card">
          <header class="header-card">
            <p>{{ $t('detailOrdreTravailTech.caracterique.infoGenerale.campagne')}}</p>
          </header>
          <div class="card-content">
            <div class="columns is-multiline">
              <b-field :label="$t('detailCampagne.informations.libelle')"
                custom-class="has-text-weight-normal is-italic is-marginless"
                class="column is-4 mgb-0">
                <router-link-blank v-if="ordreTravail.campagne"
                  classMessage="has-text-weight-bold lien mgr-5px"
                  :to="{ name: 'c.bodac.campagne',
                    params: {id: ordreTravail.campagneId}}"
                  :message="ordreTravail.campagne.libelle">
                </router-link-blank>
              </b-field>
              <b-field :label="$t('detailCampagne.informations.dateDebut')"
                custom-class="has-text-weight-normal is-italic is-marginless"
                class="column is-4 mgb-0">
                <span class="has-text-weight-bold">
                  {{ formatDate(ordreTravail.campagne.dateDebut) }}
                </span>
              </b-field>
              <b-field :label="$t('detailCampagne.informations.dateFin')"
                custom-class="has-text-weight-normal is-italic is-marginless"
                class="column is-4 mgb-0">
                <span class="has-text-weight-bold">
                  {{ formatDate(ordreTravail.campagne.dateFin) }}
                </span>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <figure class="mgt-20px">
        <ligne-commande-attachement
          :id="ordreTravail.campagneId"
            :isFullWidth="true"
          :context="constantes.module"
          :libelleImage="$t('detailOrdreTravailTech.caracterique.campagne.title',
              { name: this.ordreTravail.campagne.libelle })"
          :resizeFile="false"
            :readOnly="true"
          :permissions="constantes.ORDRE_TRAVAIL.lecture"
          :withToolTip="false">
        </ligne-commande-attachement>
      </figure>
    </div>
    <info-commandes v-if="ordreTravail.affectationsTechniquesLignesCommandeIds.length"
      :ordre-travail="ordreTravail" class="mgt-20px"></info-commandes>
    <bonSortie
      :ot="ordreTravail"
      v-if="isImpressionAffiche && ordreTravail.otStock.bonStockId"
      class="mgt-20px">
    </bonSortie>
    <taches :ordre-travail="ordreTravail" class="mgt-20px"></taches>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('piecesJointes.attachments')}}
        </p>
      </header>
      <div class="card-content">
        <app-pieces-jointes readOnly
                            deletable
                            autoSave
                            :checkPermissions=checkPermissions(constantes.ORDRE_TRAVAIL.maj)
        />
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';

import taches from '@/components/logistique/ordreTravail/tech/detail/caracterisques/taches';
import infoCommandes from '@/components/logistique/ordreTravail/tech/detail/caracterisques/infoCommandes';
import PiecesJointes from '@/components/general/piecesJointes';
import infoGenerales
  from '@/components/logistique/ordreTravail/tech/detail/caracterisques/infoGenerales';
import { ORDRE_TRAVAIL } from '@/configuration/logistique/permissionsLogistiqueConf';
import bonSortie from '@/components/logistique/ordreTravail/tech/detail/caracterisques/bonSortie';
import { IMPRESSION_AFFICHE } from '@/configuration/logistique/typeOt/typeOtConfig';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { MODULE_CAMPAGNE } from '@/configuration/general/pieceJointeConf';
import ligneCommandeAttachement from '@/components/commande/logistique/ligneCommandeAttachement';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import formatDate from '@/services/general/formatDate';

const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'LogistiqueOrdreTravailTechniqueDetailCaractéristique',
  props: {
    ordreTravail: {
      type: Object,
      required: true,
    },
    isOTImpression: {
      type: Boolean,
    },
  },
  data() {
    return {
      constantes: {
        ORDRE_TRAVAIL,
        module: MODULE_CAMPAGNE,
      },
    };
  },
  components: {
    taches,
    appPiecesJointes: PiecesJointes,
    infoGenerales,
    infoCommandes,
    bonSortie,
    ligneCommandeAttachement,
    routerLinkBlank,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    isImpressionAffiche() {
      return this.ordreTravail.typeOt?.actionInterventionOt === IMPRESSION_AFFICHE
        && this.moduleStockTiersActive;
    },
    showCampagne() {
      return this.isOTImpression
          && this.moduleImpressionActive
          && !!this.ordreTravail.campagne;
    },
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    moduleImpressionActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.demandeImpression.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    formatDate(date) {
      return formatDate(date);
    },
  },
  async mounted() {
    await this.loadParametresInterne([
      PARAMETRES_INTERNE_KEYS.moduleStockTiers.key,
      PARAMETRES_INTERNE_KEYS.demandeImpression.key,
    ]);
  },
};
</script>
